import React from 'react';

const SongCard = ({ song, onClick }) => {
  const pdfFile = song.media_files?.find(f => f.type === 'pdf');

  const handlePdfClick = (e) => {
    e.stopPropagation();
    if (pdfFile?.url) {
      if (window.umami) {
        window.umami.track('Direct PDF Download', { 
          song_slug: song.song_slug,
          title: song.title 
        });
      }
      window.open(pdfFile.url, '_blank');
    }
  };

  const handleCardClick = () => {
    if (window.umami) {
      window.umami.track('View Song Details', { 
        song_slug: song.song_slug,
        title: song.title 
      });
    }
    onClick(song.song_slug);
  };

  return (
    <div 
      onClick={handleCardClick}
      className="group bg-white p-4 rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg hover:border-blue-100 transition-all duration-300 cursor-pointer flex items-center gap-4 relative overflow-hidden"
    >
      {/* Decorative Background Blob on Hover */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-full blur-3xl -translate-y-16 translate-x-16 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      {/* Icon / Avatar */}
      <div className="w-12 h-12 flex-shrink-0 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300 shadow-sm">
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
        </svg>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0 z-10">
        <h3 className="font-bold text-gray-900 text-lg leading-tight group-hover:text-blue-700 transition-colors truncate">
          {song.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          {['HWC', 'VIP', 'CP'].includes(song.collection?.toUpperCase()) && (
            <span 
              className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-tight border ${
                song.collection?.toUpperCase() === 'HWC'
                  ? 'bg-[#595959] text-[#FFFFFF] border-[#595959]'
                  : song.collection?.toUpperCase() === 'VIP'
                    ? 'bg-[#0022B4] text-[#FFFFFF] border-[#0022B4]'
                    : song.collection?.toUpperCase() === 'CP'
                      ? 'bg-[#DA4A4A] text-[#FFFFFF] border-[#DA4A4A]'
                      : 'bg-blue-50 text-blue-600 border-blue-100'
              }`}
            >
              {song.collection} {song.track_number}
            </span>
          )}
        </div>
      </div>
      
      {/* Actions */}
      <div className="flex items-center gap-2 z-10">
        {pdfFile && (
          <button
            onClick={handlePdfClick}
            className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center hover:bg-red-500 hover:text-white text-red-600 transition-all duration-300 shadow-sm border border-red-100"
            title="Open PDF Score"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 011.414.586l5.414 5.414a1 1 0 01.586 1.414V19a2 2 0 01-2 2z" />
            </svg>
          </button>
        )}
        
        {/* Action Arrow (Details) */}
        <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors">
          <svg 
            className="w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-transform duration-300 group-hover:translate-x-0.5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default SongCard;
